function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */
import { useTranslation } from '@datacamp/le-shared-components';
import { Button } from '@datacamp/waffles/button';
import { css, jsx } from '@emotion/react';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var _ref = "production" === "production" ? {
  name: "px8pbp",
  styles: "width:90px"
} : {
  name: "1ihz68x-HintButton",
  styles: "width:90px;label:HintButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9IaW50QnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQmMiLCJmaWxlIjoiLi4vc3JjL0hpbnRCdXR0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ0BkYXRhY2FtcC9sZS1zaGFyZWQtY29tcG9uZW50cyc7XG5pbXBvcnQgeyBCdXR0b24gfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy9idXR0b24nO1xuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG50eXBlIEhpbnRCdXR0b25Qcm9wcyA9IHtcbiAgZGF0YUxhYmVsOiBzdHJpbmc7XG4gIG9uQ2xpY2s6ICgpID0+IHZvaWQ7XG59O1xuXG5leHBvcnQgY29uc3QgSGludEJ1dHRvbjogUmVhY3QuRkM8SGludEJ1dHRvblByb3BzPiA9ICh7XG4gIGRhdGFMYWJlbCxcbiAgb25DbGljayxcbn0pID0+IHtcbiAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbigpO1xuICByZXR1cm4gKFxuICAgIDxCdXR0b25cbiAgICAgIGNzcz17Y3NzYFxuICAgICAgICB3aWR0aDogOTBweDtcbiAgICAgIGB9XG4gICAgICBkYXRhLWN5PXtkYXRhTGFiZWx9XG4gICAgICBvbkNsaWNrPXtvbkNsaWNrfVxuICAgICAgc2l6ZT1cIm1lZGl1bVwiXG4gICAgPlxuICAgICAge3QoJ011bHRpU3RlcEluc3RydWN0aW9ucy5DZW50cmFsTGF5b3V0LmhpbnQnKSBhcyBzdHJpbmd9XG4gICAgPC9CdXR0b24+XG4gICk7XG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const HintButton = _ref2 => {
  let {
    dataLabel,
    onClick
  } = _ref2;
  const {
    t
  } = useTranslation();
  return jsx(Button, {
    css: _ref,
    "data-cy": dataLabel,
    onClick: onClick,
    size: "medium"
  }, t('MultiStepInstructions.CentralLayout.hint'));
};